module.exports = __webpack_public_path__ + "img/similar_icon.8b4b910f.svg";